export default "__VITE_ASSET__CeClHoZe__"